import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getIsAdmin } from 'selectors/user/session'
import { getScreenIsReady, getIsMobileScreenWidth } from 'selectors/screen'
import { getIsMobileTraffic } from 'selectors/shared/mobileTraffic'
import { getShowsIntro, getShowsItems, getTitleSlug, getShowData } from '../selectors/app'
import { getHitsResults } from '../selectors/collection'
const mapStateToProps = createStructuredSelector({
  artworks: getHitsResults,
  isMobileTraffic: getIsMobileTraffic,
  isMobileScreen: getIsMobileScreenWidth,
  isAdmin: getIsAdmin,
  isReady: getScreenIsReady,
  showData: getShowData,
  showsIntro: getShowsIntro,
  showsItems: getShowsItems,
  titleSlug: getTitleSlug,
})

const mapDispatchToProps = (dispatch) => ({})

export type ConnectorProps = {
  artworks: Array<Record<string, any>>
  isMobileTraffic: boolean
  isMobileScreen: boolean
  isAdmin: boolean
  isReady: boolean
  showData: Record<string, any>
  showsIntro: string
  showsItems: Array<Record<string, any>>
  titleSlug: string
}
export default connect(mapStateToProps, mapDispatchToProps) // Component Calls Connect